import { graphql } from "gatsby";
import React from "react";
import Layout from "../components/Layout";
import BrandStrip from "../components/home/BrandStrip";
import ContactBand from "../components/home/ContactBand";
import FeaturedProducts from "../components/home/FeaturedProducts";
import Hero from "../components/home/Hero";
import Institutional from "../components/home/Institutional";
import Promotions from "../components/home/Promotions";
import useSession from "../hooks/useSession";
import { SHOW_FEATURED_PRODUCTS } from "../config/features";

/**
 * Home V4.
 *
 * Sin sesión: primer impacto institucional, marcas y después promociones.
 * Con sesión: las promociones vigentes son lo primero, que es lo que el
 * cliente viene a mirar.
 *
 * Ojo: `isAuthenticated` recién se resuelve en el cliente, así que el primer
 * render (y el HTML estático) siempre es el de la home pública.
 */
export default function Home(props) {

	const { isAuthenticated } = useSession();
	const featuredProducts = props.data.allProducts.nodes;

	if (isAuthenticated) {
		return (
			<Layout fullBleed>
				<Promotions variant="client" />
				<BrandStrip />
				{ SHOW_FEATURED_PRODUCTS && <FeaturedProducts products={ featuredProducts } /> }
				<Institutional variant="client" />
				<ContactBand />
			</Layout>
		);
	}

	return (
		<Layout fullBleed>
			<Hero />
			<BrandStrip />
			<Promotions variant="public" />
			{ SHOW_FEATURED_PRODUCTS && <FeaturedProducts products={ featuredProducts } /> }
			<Institutional variant="public" tone="paper" />
			<ContactBand />
		</Layout>
	);
}

export const pageQuery = graphql`
    query IndexProducts {
        allProducts(filter: {is_featured: {eq: 1}}) {
            nodes {
                sku
                name
                price
                slug
            }
        }
    }
`;
